var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8333 5.62484C19.1785 5.62484 19.4583 5.34501 19.4583 4.99984C19.4583 4.65466 19.1785 4.37484 18.8333 4.37484V5.62484ZM12.1666 4.37484C11.8215 4.37484 11.5416 4.65466 11.5416 4.99984C11.5416 5.34501 11.8215 5.62484 12.1666 5.62484V4.37484ZM16.125 1.6665C16.125 1.32133 15.8451 1.0415 15.5 1.0415C15.1548 1.0415 14.875 1.32133 14.875 1.6665H16.125ZM14.875 8.33317C14.875 8.67834 15.1548 8.95817 15.5 8.95817C15.8451 8.95817 16.125 8.67834 16.125 8.33317H14.875ZM18.8333 4.37484H15.5V5.62484H18.8333V4.37484ZM15.5 4.37484H12.1666V5.62484H15.5V4.37484ZM14.875 1.6665V4.99984H16.125V1.6665H14.875ZM14.875 4.99984V8.33317H16.125V4.99984H14.875Z",
    fill: "#842234"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0833 2.5C6.35134 2.5 4.48537 2.5 3.32599 3.65937C2.16663 4.81874 2.16663 6.68472 2.16663 10.4167C2.16663 14.1486 2.16663 16.0146 3.32599 17.174C4.48537 18.3333 6.35134 18.3333 10.0833 18.3333C13.8152 18.3333 15.6812 18.3333 16.8406 17.174C18 16.0146 18 14.1486 18 10.4167V10",
    stroke: "#842234",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16663 11.7793C2.68248 11.7044 3.20399 11.6674 3.72638 11.6687C5.93633 11.622 8.09216 12.3106 9.80921 13.6117C11.4016 14.8182 12.5205 16.4789 13 18.3332",
    stroke: "#842234",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14.0803C17.0205 13.5842 16.0073 13.3325 14.9885 13.3335C13.4454 13.3275 11.9179 13.8945 10.5 15.0001",
    stroke: "#842234",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.0d4a3da122e959adbf89f288984a58c1.svg";
export { ForwardRef as ReactComponent };